<template>
  <div class="page_bg">
    <!-- 顶部返回 -->
    <div class="back_top_name flex-r-sb-c" style=" padding: 0.32rem;background: #ffffff;font-size: 0.48rem;">
      <van-icon name="arrow-left" @click="backPath" />
      <div class="top_name">委托询价</div>
      <div />
    </div>
    <!--  -->
    <div class="ask_box">
      <div class="ask_box_item" style="padding-top: 0.4rem;">
        <div class="item_title">商品图片</div>
        <div class="item_msg">
          <van-uploader v-model="fileList" :after-read="afterRead" :max-count="3" upload-icon="plus" />
        </div>
      </div>
      <van-divider />
      <div class="ask_box_item">
        <div class="item_title">商品名称<span style="color:#ED0D0D;">*</span></div>
        <div class="item_input">
          <van-field v-model="form.name" placeholder="请输入商品名称" />
        </div>
      </div>
      <van-divider />
      <div class="ask_box_item">
        <div class="item_title">商品品牌<span style="color:#ED0D0D;">*</span></div>
        <div class="item_input">
          <van-field v-model="form.brand" placeholder="请输入商品品牌" />
        </div>
      </div>
      <van-divider />
      <div class="ask_box_item">
        <div class="item_title">商品型号/规格<span style="color:#ED0D0D;">*</span></div>
        <div class="item_input">
          <van-field v-model="form.model" placeholder="请输入商品型号/规格" />
        </div>
      </div>
      <van-divider />
      <div class="ask_box_item">
        <div class="item_title">采购数量<span style="color:#ED0D0D;">*</span></div>
        <div class="item_input">
          <van-field v-model="form.num" placeholder="请输入采购数量" />
        </div>
      </div>
      <van-divider />
      <div class="ask_box_item">
        <div class="item_title">采购单价<span style="color:#ED0D0D;">*</span></div>
        <div class="item_input">
          <van-field v-model="form.price" placeholder="请输入采购单价" />
        </div>
      </div>
      <van-divider />
      <div class="ask_sub flex-r-c-c">
        <van-button round block type="info" loading-text="提交中..." native-type="resubmit" color="#0767ab"
                    style="font-size: 0.43rem;" class="next_btn " @click="sub"
        >提 交 询 价
        </van-button>
      </div>
    </div>
  </div>
</template>

<script>
import './index.scss'
import { upProToOss } from '@/utils/ali-oss'
import { wholesale_queryPrice_save } from '../../api/pro'
export default {
  data() {
    return {
      fileList: [],
      fileListcopy: [],
      form: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    next(() => {
      window.sessionStorage.setItem('lasterRouter', from.path)
    })
  },
  created() {
    if (window.name === '') {
      console.log('首次被加载')
      window.name = 'addProduct' // 在首次进入页面时我们可以给window.name设置一个固定值
    } else if (window.name === 'isReload') {
      sessionStorage.setItem('jump', true)
    }
  },
  methods: {
    backPath() { window.history.back() },
    // 图片上传
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      console.log('file', file)
      file.status = 'uploading'
      file.message = '上传中...'
      upProToOss(file).then(res => {
        file.message = '上传成功'
        file.status = 'done'
        this.fileListcopy.push(res)
        console.log('this.fileListcopy', this.fileListcopy)
        console.log('this.fileList', this.fileList)
      }).catch(() => {
        setTimeout(() => {
          file.status = 'failed'
          file.message = '上传失败'
        }, 1000)
      })
    },
    // 提交
    sub() {
      this.$set(this.form, 'img', this.fileListcopy)
      wholesale_queryPrice_save(this.form).then(res => {
        this.$toast({ message: '提交成功！', duration: 1 * 1000 })
        window.history.back()
      })
    }
  }
}
</script>

<style>
</style>
